import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const BuyeasySupplierInformationTranslations = wrapTranslationsSchema({
	name: 'BuyEasySupplierInformationTranslations',
	title: 'Information Section Translations',
	sanityId: 'buyeasy-supplierInformation',
	fields: {
		informationSectionTitle: 'Supplier Information',
		address: 'Address',
		other: 'Other',
		city: 'City',
		country: 'Country',
		contractId: 'Contract ID',
		contractTitle: 'Contract Title',
		contractSubCategory: 'Contract Subcategory',
		title: 'Title',
		subcategory: 'Subcategory',
		effectiveDate: 'Effective Date',
		moreInformationInMalbek: 'More information in Malbek',
		requester: 'Requester',
		contacts: 'Contacts',
		supplierNo: 'Supplier #',
		noContacts: 'no contacts information available',
		primaryContact: 'Primary',
		additionalInfo: 'Additional Information',
		sbti: 'Climate SBTI Commitment',
		diversityIndicators: 'Diversity Indicators',
		takedaSupplierOwner: 'Takeda Supplier Owner',
		checkRnDLink: 'Check R&D ASL',
		contracts: 'Contracts',
		expirationDate: 'Expiration Date',
		evergreen: 'Evergreen',
		noContracts: 'no contracts information available',
		globalParent: 'Global Parent',
		supplierId: 'Supplier ID',
		basicInformation: 'Basic Information',
		anid: 'ANID',
		industryKey: 'Industry key',
		viewItInOtherLanguages: 'View it in other languages',
		supplierContacts: 'Supplier Contacts',
		supplierContactsPrimary: 'Supplier Contact - Primary',
		companyCodes: 'Company Codes',
		financialInformation: 'Financial Information',
		taxId: 'Tax ID',
		vatId: 'VAT ID',
		piiRemovedTitle: 'Private information',
		piiRemovedMessage: 'Hidden to protect personal info.',
		eInvoiceEnabled: 'E-Invoice Enabled',
		subcontractor: 'Subcontractor',
		freelancer: 'Freelancer',
		see: 'See',
		tssp: 'Takeda Supplier Portal (TSSP)',
		purchasingInformationSectionTitle: 'Purchasing Information',
		takedaPurchasingInformation: 'Takeda Purchasing Information',
		approvedSupplierList: 'Approved Supplier List',
		approvedSupplierListGMSGQUrl: '',
		approvedSupplierListRDASLUrl:
			'https://onetakeda.us.qlikcloud.com/sense/app/46fda9f3-bba9-43a2-85e7-a4bbfd64c92a/overview',
		mdg: 'MDG',
		mdgContact: 'MDG Contact',
		mdgContacts: 'MDG Contacts',
		noCompanyCodes: 'Your Company Code is not listed for this Supplier',
		yourCompanyCodeAvailable: 'Your Company Code is available',
		yourCompanyCodeNotAvailable: 'Your Company Code is not listed for this Supplier',
		usersCompanyCodeNotListed: 'User’s Company Code is not listed for this Supplier',
		noEmailRegistered: 'No email registered for User’s Company Code',
		noEmail: 'No email registered',
		results: 'results',
		search: 'Search',
		procurementContact: 'Procurement Contact',
		procurementContactPrimary: 'Procurement Contact - Primary',
		contactsTooltip:
			'For business topics and contracting, contact the Supplier Contact. For tactical purchasing, contact the PO (Purchase Order) Contact.',
		supplierOwnerTooltip:
			'Takeda Supplier Owner is responsible for managing any issues that occur with the Supplier.',
		companyCodesTooltip:
			'Users with the listed Company Codes can purchase from the supplier. If you see a highlighted one, it means you can purchase from the Supplier too.',
		basicInformationTooltip:
			"ANID is the supplier's SAP Business Account Network ID, supporting supplier queries. Industry Key further classifies the supplier type (e.g. Freelance, Utility Suppliers).",
		contractsTooltip:
			'Agreement contract between Takeda and the Supplier, underpinning separate Statement of Work. If expired, contact the Takeda Supplier Owner.',
		additionalInfoToolTip:
			'Climate SBTi Commitment: Supplier meets Science-Based Target Initiative. Diversity Indicator: Supplier meets small/diverse requirements. ASL: links to Approved Suppliers Lists, see local QMS for info',
	},
});
